<template>
  <div>
    <h1 class="mb-4 bold-medium">Solicitações de Reprocessamento</h1>
    <summary-filter
      @save-filter="saveFilter"
      @skeleton-handler="skeletonHandler"
    />
    <smart-card class="mt-4 p-1" v-if="loading">
      <smart-skeleton-loading :items="1" :height="8" />
    </smart-card>
    <div
      v-else-if="
        (!loading && homeBrokerList != null) || homeBrokerList.length > 0
      "
    >
      <template>
        <div
          v-for="(homeBrokerDistributor, index) in computedHomeBrokerList"
          :key="`listing - ${index} - ${homeBrokerDistributor.id}`"
        >
          <div
            v-for="(homeBroker, index) in homeBrokerDistributor.data"
            :key="`distributor - ${index} - ${homeBroker.id}`"
          >
            <approval-list
              v-if="homeBroker.items.length"
              :key="`${index} - ${homeBroker.id}`"
              :index="index"
              v-bind="homeBroker"
              :homeBroker="homeBroker"
              :distributor="homeBrokerDistributor.distributor"
              :referenceDate="homeBrokerDistributor.referenceDate"
              :hasValue="homeBrokerDistributor.hasValue"
              :action="homeBroker.action"
              @fetch-home="fetchHomeChanged"
            />
          </div>
        </div>
      </template>
    </div>
    <div v-else>
      <div class="main-wrapper bg-white align-center with-border-radius">
        <div class="flex align-center flex-row div-flex-control">
          <section class="bigger-section text-center">
            <h2>Não há movimentações</h2>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "HomeBrokerMain",
  components: {
    SummaryFilter: () => import("./components/SummaryFilter.vue"),
    ApprovalList: () => import("./components/ApprovalList.vue"),
  },
  data() {
    return {
      currentFilter: {},
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      homeBrokerList: "homeBroker/homeBrokerList",
      isDB: "auth/isDB",
      idUser: "auth/idUser",
      distributorsList: "homeBroker/distributorsByUser",
    }),
    computedHomeBrokerList() {
      let hasValue = "";

      this.homeBrokerList.length == 0 ? (hasValue = 0) : (hasValue = 1);

      return this.homeBrokerList.map((homeBroker) => ({
        distributor: homeBroker.distributor,
        referenceDate: homeBroker.referenceDate,
        data: homeBroker.data,
        hasValue: hasValue,
      }));
    },
  },
  async mounted() {
    this.distributors();
    await this.fetchConfidenceSigtimLogin();

    let distributorId =
      this.distributorsList.length > 0 ? this.distributorsList[0].id : -1;
    let DTO = {};
    this.isDB ? (DTO = { distributor: distributorId }) : "";

    this.fetchHomeBrokerList({ DTO });
  },
  methods: {
    ...mapActions({
      fetchConfidenceSigtimLogin: "homeBroker/fetchConfidenceSigtimLogin",
      fetchHomeBrokerList: "homeBroker/fetchHomeBrokerList",
      distributors: "homeBroker/fetchDistributors",
    }),
    skeletonHandler(state) {
      this.loading = state;
    },
    saveFilter(filter) {
      this.currentFilter = { ...filter };
    },
    fetchHomeChanged() {
      this.fetchHomeBrokerList();
    },
  },
};
</script>

<style lang="scss">
// ----- tabela deitada componente ApprovalList -----
div.elevation-1.vertical__table {
  box-shadow: none !important;
  div.v-table__overflow {
    table.v-datatable.v-table,
    thead,
    tbody,
    tr,
    th,
    td {
      display: flex !important;
    }
    table.v-datatable.v-table {
      overflow: hidden;
      flex-direction: row;
      width: 100%;
      thead,
      tbody {
        tr {
          width: 100%;
          border: none;
          flex-direction: column;
          height: 100%;
          &.v-datatable__progress {
            display: none !important;
          }
          td,
          th {
            font-size: 12px;
            display: flex;
            width: 100% !important;
            height: 48px !important;
            justify-content: flex-start;
            align-items: center;
            border: none;
            border-bottom: thin solid rgba(0, 0, 0, 0.12);
            i {
              display: none;
            }
          }
          th {
            color: grey;
            width: 168px !important;
            height: 48px !important;
            justify-content: flex-start;
            position: relative;
            text-align: right;
            padding-right: 8px;
          }
        }
      }
      tbody {
        width: 100%;
        overflow-x: scroll;
      }
    }
  }
  div.v-datatable__actions {
    display: none;
  }
}
// ----- tabela deitada componente ApprovalList -----

.bold-medium {
  font-weight: 500;
}

.main-wrapper {
  display: block;
  padding: 2%;
  border: 1px solid #e3e5e6;
  height: auto;
  margin-right: 2px;
  margin-top: 15px;
  position: relative;
}

.with-border-radius {
  border-radius: 6px;
}

.bigger-section {
  display: table;
  width: 100%;
  header {
    div {
      font-size: 12px;
      color: grey;
      padding: 0 0 2% 0;
    }
  }
}

@media only screen and (max-width: 600px) {
  .bigger-section {
    width: 100%;
    .title-header {
      font-size: 17px;
      color: grey;
      padding: 0 0 3% 0;
    }
    .content-header {
      font-size: 20px;
      padding: 0 0 7% 0;
    }
  }
}
</style>
